import type { EntityInfo } from "@/lib/entityInfo";
import type { PartyEntitiesData, EntitiesData } from "@/lib/newsimulator/simulator";
import type { Settings } from "@/lib/trashsim/settings";
import { getEntities } from "./fleet";
import type { Party } from "../party";
import { CreateEntityData } from "../entities";


function CreateSimulationParty(party: Party, entityInfo: EntityInfo, settings: Settings): PartyEntitiesData {
    let result: PartyEntitiesData = []

    party.fleets.forEach((fleet, index) => {
        console.log('fleet', fleet)
        let entities = getEntities(fleet)

        let data: EntitiesData = {}
        for (const entityId in entities) {
            const entityData = CreateEntityData(entityId, entities[entityId], entityInfo[entityId], fleet, settings)

            entityData.weapon = Math.floor(entityData.weapon)
            entityData.shield = Math.floor(entityData.shield)
            entityData.armor = Math.floor(entityData.armor)
            entityData.cargo = entityData.cargo ? Math.floor(entityData.cargo) : undefined;
            entityData.fuel = entityData.fuel ? Math.floor(entityData.fuel) : undefined;
            entityData.speed = entityData.speed ? Math.floor(entityData.speed) : undefined;

            data[entityId] = entityData
        }
        result[index] = data
    })

    return result
}

function CreateCalculationParty(party: Party, entityInfo: EntityInfo, settings: Settings): PartyEntitiesData {
    return <PartyEntitiesData>{}
}

export {
    CreateSimulationParty,
    CreateCalculationParty
}